import React from 'react';

interface LandingPageProps {
  onEnter: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onEnter }) => {
  return (
    <div
      className="flex items-center justify-center w-screen h-screen cursor-pointer"
      onClick={onEnter}
    >
      <h1 className="text-3xl font-semibold text-white">Click Anywhere</h1>
    </div>
  );
};

export default LandingPage;